import { UserState } from '../../types/user-module.types';

export const state: UserState = {
  user: {
    loggedIn: false,
    data: undefined,
  },
};
